// PN-15 (T-432) — mots de l'onglet « Aides complémentaires » : jamais un code brut (`canal`, `aide_type`), et un badge de statut qui DÉRIVE du verdict calculé.
import { VERDICTS } from "./VerdictAide";

export const LIBELLE_CANAL = { email: "Email", courrier: "Courrier", formulaire_web: "Formulaire en ligne", telephone: "Téléphone" };
export const LIBELLE_TYPE_AIDE = {
  caisse_retraite: "Caisse de retraite", departement: "Département", region: "Région", ville: "Ville", mutuelle: "Mutuelle", autre: "Autre",
};
const lisible = (code) => { const t = String(code || "").replace(/_/g, " ").trim(); return t ? t.charAt(0).toUpperCase() + t.slice(1) : "—"; };
export const libelleCanal = (c) => LIBELLE_CANAL[c] || lisible(c);
export const libelleTypeAide = (t) => LIBELLE_TYPE_AIDE[t] || lisible(t);

/** Statuts d'AVANT le suivi : le badge ne les invente pas, il reprend le verdict calculé (`source_verdict === "code"`). Les suivants (en cours, déposée…)
 *  sont des faits de suivi saisis par l'équipe : ils restent tels quels. Sans verdict calculé (ancienne analyse), « À confirmer » : jamais « Éligible ». */
export const STATUTS_DERIVES_DU_VERDICT = ["eligible", "non_etudiee"];

export function statutAffiche(aide) {
  if (!STATUTS_DERIVES_DU_VERDICT.includes(aide?.statut)) return null;
  const v = aide?.source_verdict === "code" ? aide.verdict : null;
  const cfg = (v && VERDICTS[v]) || VERDICTS.indetermine;
  return { label: cfg.label, color: cfg.color, bg: cfg.bg, verdict: (v && VERDICTS[v]) ? v : "indetermine" };
}
